/**
 *
 * Asynchronously loads the component for ReservationDetailsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ReservationDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.ReservationDetailsPage,
);
